import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from 'app/services/general.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  isLogin=false;
  constructor(
    private router: Router,
    private gralService: GeneralService
    ) {

    gralService.changeTextHead('CONTACT');
    let url = this.router.url.valueOf();
    console.log(url);

    let state = url.split('/');
    if(state[1] == 'contactSmp'){
      this.isLogin = true;
    }

   }

  ngOnInit() {
  }

}
